module.exports = __webpack_public_path__ + "img/BG-DataScience.6eed07c4.jpg";